import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { SelectNumbersTable } from '@components/Order/Numbers/SelectNumbers/SelectNumbersTable';
import SelectedNumbersTable from '@components/Order/Numbers/SelectNumbers/SelectedNumbersTable';
import { cartApi } from '@reducers/order';
import { planDetailsApi } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const SelectNumbers = () => {
  const { id, type, prefixID } = useParams();
  const queryArg = id && prefixID ? { id, type, prefixID } : skipToken;
  return (
    <Row>
      <Col md={9}>
        <SelectNumbersTable
          useData={planDetailsApi.useGetPrefixAvailableDidsQuery}
          useDataArgs={queryArg}
        />
      </Col>
      <Col md={3}>
        <SelectedNumbersTable
          useData={cartApi.useGetForPlanQuery}
          useDataArgs={queryArg}
        />
      </Col>
    </Row>
  );
};
